<template>
  <div class="page-403">
    <div class="box">
      <span class="a">4</span>
      <div class="compass">
        <div class="glass"></div>
        <div class="needle"><span class="pin"></span></div>
        <div class="directions"><span>N</span><span>E</span><span>S</span><span>W</span></div>
        <div class="sub_directions">
          <span>NE</span><span>SE</span><span>SW</span><span>NW</span>
        </div>
      </div>
      <span class="b">3</span>
    </div>
    <div class="msg">
      我们了解您的请求，但无法让您访问您输入的链接，建议您在你迷路之前离开这个地方<br />
      <a class="btn" @click="handleSkip">返回登录页</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'page-403',
  components: {},
  props: {},
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {
    handleSkip() {
      this.$router.push('/')
    },
  },
}
</script>

<style lang="less" scoped>
.page-403 {
  @shadow: #222;
  @outline: #222;
  @outline-t: #135b63;
  @outline-w: 2px;

  width: 100vw;
  height: 100vh;
  background: linear-gradient(to bottom, #004680, #c7c7c7 74%, #efb053 75%, #944416);
  display: flex;
  justify-content: center;
  align-items: center;

  user-select: none;
  font: 700 1rem 'Cinzel';
  color: #eee;
  height: 100vh;
  margin: 0;
  padding: 0;

  .box {
    width: 400px;
    display: flex;
    justify-content: center;
    align-items: center;
    transform: scale(1);
    transition: transform 0.5s;
    transform-style: preserve-3d;
    perspective: 1000px;

    &::before {
      text-shadow: 0 3px 5px #1b3f44, 0 -3px 5px #9de2f8;
      content: 'Error';
      position: absolute;
      top: -9.5rem;
      font-size: 6rem;
    }

    &::after {
      text-shadow: 0 3px 5px #1b3f44, 0 -3px 5px #9de2f8;
      content: '您没有访问该页面的权限!';
      position: absolute;
      top: -2.5rem;
      font-size: 1rem;
    }

    & .a,
    & .b {
      display: inline-block;
      position: absolute;
      top: 45%;
      font-size: 14rem;
      color: #f2f2f2;
      font: 900 15rem 'Martel';
      transform: translate(-50%, -50%);
      transition: all 0.4s;
      text-shadow: 0 2px 0 @outline-t, 0 -2px 0 @outline-t, -2px 0 0 @outline-t, 2px 0 0 @outline-t,
        2px 2px 0 @outline-t, 2px -2px 0 @outline-t;
      z-index: -1;
    }
    & .a {
      left: 0;
    }
    & .b {
      left: 100%;
    }
  }

  .compass {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
    width: 200px;
    background: radial-gradient(#777 5%, #eee 10%, #fff 30%, #777);
    border: 3 * @outline-w solid @outline;
    border-radius: 50%;
    transition: transform 0.3s, box-shadow 0.3s;
    transform: rotateX(45deg);
    box-shadow: 0 10px 0 @shadow, 0 20px 0 @shadow, 0 30px 0 @shadow, inset 0 0 100px #eaeaea,
      inset 0 0 0 5px #456;
    transform-style: preserve-3d;
    perspective: 300px;

    &::after {
      content: '';
      position: absolute;
      height: 100%;
      width: 100%;
      transform: translateZ(-90px);
      border-radius: inherit;
      box-shadow: 0 0 100px #000;
    }

    &:hover {
      transform: rotateX(0deg);
      box-shadow: 0 0 0 @shadow, 0 0 0 @shadow, 0 0 0 @shadow, inset 0 0 100px #aaa,
        inset 0 0 0 5px #456;
    }
    & .glass {
      position: absolute;
      height: 98%;
      width: 98%;
      border-radius: inherit;
      transition: all 0.2s;
      transform: translatez(6px);

      &:hover::after {
        animation: shimmer 0.5s ease both;
        @keyframes shimmer {
          to {
            background-position: 0;
          }
        }
      }
      &::after {
        transform: rotate(45deg);
        content: '';
        position: absolute;
        height: 100%;
        width: 100%;
        border-radius: inherit;
        background: linear-gradient(to right, rgba(#fff, 0.5), transparent, rgba(#fff, 0.5));
        background-position: -12em;
      }
    }
    & .needle {
      border-radius: 50%;
      width: 10px;
      height: 10px;
      padding: 0px;
      background: #222;
      position: relative;
      box-shadow: 0 0 0 3px #ddd;
      transition: transform 2s;
      animation: rotate 10s cubic-bezier(0.15, -0.6, 0.39, 1.6) alternate infinite both;

      @keyframes rotate {
        0% {
          transform: rotate(-50deg) translateZ(5px);
        }
        11% {
          transform: rotate(720deg) translateZ(5px);
        }
        16% {
          transform: rotate(700deg) translateZ(5px);
        }
        30% {
          transform: rotate(360deg) translateZ(5px);
        }
        35% {
          transform: rotate(500deg) translateZ(5px);
        }
        50% {
          transform: rotate(0deg) translateZ(5px);
        }
        60% {
          transform: rotate(156deg) translateZ(5px);
        }
        78% {
          transform: rotate(654deg) translateZ(5px);
        }
        85% {
          transform: rotate(40deg) translateZ(5px);
        }
        90% {
          transform: rotate(400deg) translateZ(5px);
        }
        98% {
          transform: rotate(1400deg) translateZ(5px);
        }
        100% {
          transform: rotate(-450deg) translateZ(5px);
        }
      }

      &::before,
      &::after {
        content: '';
        position: absolute;
        height: 100px;
        z-index: -1;
        border-radius: 10px;
      }
      &::before {
        left: -2px;
        bottom: 0;
        border-style: solid;
        border-color: transparent transparent red transparent;
        border-width: 0 7px 70px 7px;
      }

      &::after {
        transform: rotate(180deg);
        top: 0;
        left: -2px;
        border-style: solid;
        border-color: transparent transparent #333 transparent;
        border-width: 0 7px 70px 7px;
      }

      & .pin {
        position: absolute;
        padding: 5px;
        border: @outline-w solid #eee;
        box-shadow: 0 0 0 3px #ddd;
        border-radius: 50%;
        background-color: #000;
        top: -2px;
        left: -2px;
      }
    }
  }

  .directions,
  .sub_directions {
    color: #000;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    z-index: 1;
    height: 100%;
    width: 100%;

    & span {
      font-size: 1.2rem;
      position: absolute;
      &:nth-child(1) {
        top: 5px;
      }
      &:nth-child(2) {
        right: 10px;
      }
      &:nth-child(3) {
        bottom: 5px;
      }
      &:nth-child(4) {
        left: 10px;
      }
    }
  }

  .sub_directions {
    transform: rotate(45deg) scale(0.9);
    & span {
      font-size: 1rem;
      transform: rotate(-45deg);
      position: absolute;
      &:nth-child(1) {
        top: 15px;
      }
      &:nth-child(2) {
        right: 10px;
      }
      &:nth-child(3) {
        bottom: 10px;
      }
      &:nth-child(4) {
        left: 10px;
      }
    }
  }

  .msg {
    letter-spacing: 1px;
    position: absolute;
    bottom: 20px;
    width: 80%;
    background: rgba(black, 0.4);
    padding: 0.6em;
    text-align: center;
    border-radius: 6px;

    & .btn {
      cursor: pointer;
      display: inline-block;
      margin: 10px 0;
      color: #fff;
      text-decoration: dashed;
      background-color: rgba(#000, 0.4);
      padding: 8px 12px;
      border-radius: 5px;
      box-shadow: 0 2px 2px #222;
      &:hover {
        color: lighten(white, 10%);
        box-shadow: 0 0 0 1px rgba(white, 0.2);
      }
    }
  }

  @media screen and (max-width: 768px) {
    .box {
      transform: scale(0.9);
    }
    .msg {
      width: 80%;
    }
  }

  @media screen and (max-width: 640px) {
    .box {
      transform: scale(0.7);
    }
    .msg {
      font-size: 0.8rem;
    }
  }

  @media screen and (max-width: 480px) {
    body {
      overflow: hidden;
    }
    .box {
      width: 400px;
    }
  }

  @media screen and (max-width: 440px) {
    .box {
      transform: scale(0.6);
    }
  }

  @media screen and (max-width: 320px) {
    .box {
      transform: scale(0.5);
      width: 300px !important;
    }
  }
}
</style>
